import React from 'react';
import { Flex, Button, Box, Dialog } from '@radix-ui/themes';
//import { } from '@radix-ui/react-icons';


/**
 * This is the header of the logged user
 * This is used to diplay the main informations
 */
const Code = (content) => {

    return  <Dialog.Root>
            <Dialog.Trigger>

                <Box>
                <Box style={{
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "25px",
                        display: "flex",
                    }}>
                        <Button size="3" color="bronze">
                            J'ai un code d'activation
                        </Button>
    
                    </Box>
        

                </Box>
                
                
            </Dialog.Trigger>

            <Dialog.Content style={{ maxWidth: 550 }}>
                <form
                onSubmit={async (event) => {
                    event.preventDefault();
                    const code = document.getElementById('invit_code').value;
                    
                    const cookie = document.cookie.split(';').find(cookie => cookie.startsWith('token') || cookie.startsWith(' token'));
                    const token = cookie ? cookie.split('token=')[1] : null;

                    try {
                        // contact the api
                        const req = await fetch('https://kissaten.koffy.finance/subscribe/code', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                "Authorization": `Bearer ${token}`
                            },
                            body: JSON.stringify({
                                code: code
                            }),
                        })
                        const res = await req.json();
                        if(res.error) {
                            alert(res.error_description);
                        }
                        window.location.href = "/"
                    } catch(err) {}
                }}>
                    <Dialog.Title>
                        Code d'activation
                    </Dialog.Title>
                    <Dialog.Description size="2" mb="4">
                        Vous avez un code d'activation ? Entrez le ici pour profiter de votre accès à la plateforme.
                    </Dialog.Description>

                    <Box style={{
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                    }}>
                        <Flex direction="column" gap="3">
                            <label>
                                <input type='text' id='invit_code' placeholder='Code' style={{
                                    border: "1px solid #eaeaea",
                                    borderRadius: "4px",
                                }}/>
                            </label>
                        </Flex>
                    </Box>

                    <Flex gap="3" mt="4" justify="end">
                        <Dialog.Close>
                            <Button variant="soft" color="gray">
                                Cancel
                            </Button>
                        </Dialog.Close>
                        <Dialog.Close>
                            <Button type='submit' id="stripe">Valider le code</Button>
                        </Dialog.Close>
                    </Flex>
                </form>
            </Dialog.Content>
        </Dialog.Root>


}

export default Code;